import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'contract-create-error-modal',
    templateUrl: './contract-create-error-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContractCreateErrorModalComponent {
  @Input() text: string;
}
